import { useSelector } from "react-redux";
import { selectCurrentUserInfo } from "../store/feautures/AuthSlice";
import CardDashboard from "../components/main/CardDashboard";
import { SuperAndAdvance } from "../utils/genericList/ListRoleRoutes";
import { ClockIcon, SquaresPlusIcon, CalendarDaysIcon } from "@heroicons/react/24/outline";

export default function HomePage() {

    const {name, lastname}: any = useSelector(selectCurrentUserInfo);
    const { role } = useSelector(selectCurrentUserInfo);

    return(
        <>
            <h2 className="text-xl my-6">Home</h2>
            <p>Benvenuto, {name} {lastname}</p>

            <div className="grid xl:grid-cols-4 lg:grid-cols-3 md:grid-cols-2 grid-cols-1 my-10 gap-x-6 gap-y-12">
               {SuperAndAdvance.includes(role) && <CardDashboard title="Aziende" icon={SquaresPlusIcon} url="/dashboard/agency" labelBtn="Vai a gestione aziende" />}
               {SuperAndAdvance.includes(role) && <CardDashboard title="Limita Appuntamenti" icon={ClockIcon} url="/dashboard/appointments" labelBtn="Vai al calendario" />}
               {!['Speaker', 'Consulente'].includes(role) && <CardDashboard title="Calendario Appuntamenti" icon={CalendarDaysIcon} url="/dashboard/appointments-days" labelBtn="Vai al calendario" />}
            </div>
        </>
    )
}
